<!-- @format -->

<app-create-asin-header></app-create-asin-header>

<div
	class="land-bg"
	[style]="minHeight"
>
	<div
		class="container mb-4"
		[style]="minHeight2"
	>
		<div style="padding: 50px 30px">
			<div class="row justify-content-center">
				<div class="col-md-10">
					<div class="question-card">
						<div
							class="page-header"
							*ngIf="isInPreviewMode"
						>
							<button
								class="btn btn-secondary back-btn"
								(click)="goBackToEditingMode()"
							>
								<span class="material-icons"> arrow_back </span>
								Back
							</button>
							Preview
						</div>

						<div
							class="verification"
							*ngIf="!isInPreviewMode"
						>
							<div
								class="verification-question mb-3 d-inline-flex gap-3"
							>
								<span class="fw-bolder"
									>Is Business Registered With CAC?</span
								>
								<div class="answers d-inline-flex gap-2">
									<label class="radio-answer">
										<input
											type="radio"
											name="registeredWithCac"
											[(ngModel)]="registeredWithCac"
											[value]="true"
										/>
										Yes
									</label>
									<label class="radio-answer">
										<input
											type="radio"
											name="registeredWithCac"
											[(ngModel)]="registeredWithCac"
											[value]="false"
											(click)="clearCacData()"
										/>
										No
									</label>
								</div>
							</div>
							<form
								[formGroup]="cacForm"
								(ngSubmit)="verifyCAC()"
								*ngIf="registeredWithCac"
								class="cac-form"
							>
								<div class="cac-form-body">
									<div class="cac-form-input">
										<div class="input-group-div">
											<input
												appOnlyNumber
												placeholder="ENTER BN."
												formControlName="cac"
											/>
										</div>
										<div class="input-group-div">
											<input
												placeholder="Company Name"
												formControlName="companyName"
											/>
										</div>
									</div>
									<button
										type="submit"
										[disabled]="!cacForm.get('cac').valid"
										class="btn btn-gold d-flex justify-content-center align-items-center gap-2"
									>
										<b
											*ngIf="isVerifyingCAC"
											class="spinner-border text-white"
										></b>
										Verify
									</button>
								</div>
								<app-error-message
									[form]="cacForm"
									[controlName]="'cac'"
									[label]="'CAC business number'"
								></app-error-message>
							</form>
						</div>
						<form
							[formGroup]="basicForm"
							(ngSubmit)="onSubmit()"
							*ngIf="!registeredWithCac || cacVerified"
						>
							<br />
							<div class="row">
								<div class="form-panel">
									<p>Business Section</p>

									<div class="row">
										<div class="col-md-4 mb-3">
											<div class="input-group-div">
												<label class="required"
													>Business Name</label
												>
												<input
													name="corporateName"
													formControlName="corporateName"
												/>
												<app-error-message
													[form]="basicForm"
													[controlName]="
														'corporateName'
													"
													[label]="'Business name'"
												></app-error-message>
											</div>
										</div>

										<div class="col-md-4 mb-3">
											<div class="input-group-div">
												<label
													>Date Of Commencement Of
													Business</label
												>
												<input
													type="date"
													style="letter-spacing: 2px"
													formControlName="dateOfCommencement"
												/>
												<app-error-message
													[form]="basicForm"
													controlName="dateOfCommencement"
													[label]="
														'Date Of commencement'
													"
												></app-error-message>
											</div>
										</div>

										<div class="col-md-4 mb-3">
											<div class="action-input-group">
												<label class="mb-0"
													>Business Email</label
												>
												<div class="input">
													<input
														type="text"
														class="mt-0"
														formControlName="businessContactEmail"
													/>
													<button
														class="btn btn-secondary send-otp-btn"
														(click)="
															sendOTPtoEmail()
														"
														type="button"
														[disabled]="
															basicForm.get(
																'businessContactEmail'
															).invalid
														"
													>
														<span
															*ngIf="
																!isSendingOTPtoEmail
															"
															>SEND OTP</span
														>
														<div
															class="spinner-border text-white"
															*ngIf="
																isSendingOTPtoEmail
															"
														></div>
													</button>
												</div>
												<app-error-message
													[form]="basicForm"
													controlName="businessContactEmail"
													label="Business email"
												></app-error-message>
											</div>
										</div>

										<div class="col-md-4 mb-3">
											<div class="action-input-group">
												<label class="mb-0"
													>Business Phone</label
												>
												<div class="input">
													<input
														type="text"
														class="mt-0"
														formControlName="businessContactPhoneNumber"
													/>
													<button
														class="btn btn-secondary send-otp-btn"
														(click)="sendOTPtoSMS()"
														type="button"
														[disabled]="
															basicForm.get(
																'businessContactPhoneNumber'
															).invalid
														"
													>
														<span
															*ngIf="
																!isSendingOTPtoSMS
															"
															>SEND OTP</span
														>
														<div
															class="spinner-border text-white"
															*ngIf="
																isSendingOTPtoSMS
															"
														></div>
													</button>
												</div>
												<app-error-message
													[form]="basicForm"
													controlName="businessContactPhoneNumber"
													label="Business phone number"
												></app-error-message>
											</div>
										</div>

										<div class="col-md-4 mb-3">
											<div class="input-group-div">
												<label class="required"
													>Ownership Type</label
												>
												<select
													formControlName="ownershipType"
												>
													<option
														selected
														disabled
													>
														-- SELECT OWNERSHIP TYPE
														--
													</option>
													<option value="PARTNERSHIP">
														PARTNERSHIP
													</option>
													<option
														value="SOLE-PROPIETORSHIP"
													>
														SOLE-PROPIETORSHIP
													</option>
												</select>
												<app-error-message
													[form]="basicForm"
													controlName="ownershipType"
													label="Ownership type"
												></app-error-message>
											</div>
										</div>

										<div class="col-md-4 mb-3">
											<div class="input-group-div">
												<label class="required"
													>Nature Of Business</label
												>
												<select
													formControlName="natureOfBusiness"
												>
													<option
														selected
														disabled
													>
														-- SELECT OPTION --
													</option>
													<option value="COMPANY">
														COMPANY
													</option>
													<option
														value="INCORPORATED_TRUSTEE"
													>
														INCORPORATED TRUSTEE
													</option>
													<option
														value="INCORPORATED_TRUSTEE"
													>
														INCORPORATED TRUSTEE
													</option>
													<option
														class="BUSINESS_NAME"
													>
														BUSINESS NAME
													</option>
													<option
														value="LIMITED_PARTNERSHIP"
													>
														LIMITED_PARTNERSHIP
													</option>
													<option
														value="LIMITED_LIABILITY_PARTNERSHIP"
													>
														LIMITED_LIABILITY_PARTNERSHIP
													</option>
												</select>
											</div>
										</div>

										<div class="col-md-4 mb-3">
											<div class="input-group-div">
												<label class="required"
													>No. Of Branches</label
												>
												<input
													formControlName="numberOfBranches"
													type="number"
													min="0"
												/>
												<app-error-message
													[form]="basicForm"
													controlName="numberOfBranches"
													label="No. Of branches"
												></app-error-message>
											</div>
										</div>

										<div class="col-md-4 mb-3">
											<div class="input-group-div">
												<label class="required"
													>No. Of Staff</label
												>
												<input
													formControlName="numberOfEmployees"
													type="number"
													min="0"
												/>
												<app-error-message
													[form]="basicForm"
													controlName="numberOfEmployees"
													label="No. Of staff"
												></app-error-message>
											</div>
										</div>

										<div class="col-md-4 mb-3">
											<div class="input-group-div">
												<label class=""
													>Average Salary Of Staff
													<span class="fw-bold"
														>₦</span
													>(Optional)</label
												>
												<input
													formControlName="averageStaffSalary"
													type="number"
													min="0"
												/>
												<app-error-message
													[form]="basicForm"
													controlName="averageStaffSalary"
													label="Average salary Of staff"
												></app-error-message>
											</div>
										</div>

										<div class="col-md-4 mb-3">
											<div class="input-group-div">
												<label class="required"
													>Number Of Vehicles
													Owned</label
												>
												<input
													formControlName="vehicleCount"
													type="number"
													min="0"
												/>
												<app-error-message
													[form]="basicForm"
													controlName="vehicleCount"
													label="No. Of staff"
												></app-error-message>
											</div>
										</div>

										<div class="col-md-4 mb-3">
											<div class="input-group-div">
												<label class="required"
													>State</label
												>
												<select
													formControlName="businessState"
													(change)="getLga()"
												>
													<option value="">
														Select State
													</option>
													<option
														[value]="state.id"
														*ngFor="
															let state of state
														"
													>
														{{ state.name }}
													</option>
												</select>
												<app-error-message
													[form]="basicForm"
													controlName="businessState"
													label="State"
												></app-error-message>
											</div>
										</div>
										<div class="col-md-4 mb-3">
											<div class="input-group-div">
												<label class="required"
													>LGA</label
												>
												<select
													formControlName="businessLga"
													(change)="getArea()"
												>
													<option value="">
														Select LGA
													</option>
													<option
														[value]="state.id"
														*ngFor="
															let state of lga
														"
													>
														{{ state.name }}
													</option>
												</select>
												<app-error-message
													[form]="basicForm"
													controlName="businessLga"
													label="LGA"
												></app-error-message>
											</div>
										</div>
										<div class="col-md-4 mb-3">
											<div class="input-group-div">
												<label class="required"
													>Area</label
												>
												<select
													formControlName="businessArea"
													*ngIf="
														areas &&
														areas.length > 0
													"
												>
													<option value="">
														Select Area
													</option>
													<option
														*ngFor="
															let area of areas
														"
														[value]="area.id"
													>
														{{ area.name }}
													</option>
												</select>
												<input
													*ngIf="
														!areas ||
														(areas &&
															areas.length <= 0)
													"
													type="text"
													formControlName="businessArea"
												/>
												<app-error-message
													[form]="basicForm"
													controlName="businessArea"
													label="Area"
												></app-error-message>
											</div>
										</div>

										<div class="col-md-4 mb-3">
											<div class="input-group-div">
												<label class="required"
													>Full Address</label
												>
												<input
													type="text"
													formControlName="businessAddress"
												/>
											</div>
											<app-error-message
												[form]="basicForm"
												controlName="businessAddress"
												label="Full address"
											></app-error-message>
										</div>
										<div
											class="col-md-4 mb-3 d-flex align-items-center"
										>
											<div
												class="verification-question d-inline-flex gap-3"
											>
												<span class="fw-semibold"
													>Is the business premises
													rented?</span
												>
												<div
													class="answers d-inline-flex gap-2"
												>
													<label class="radio-answer">
														<input
															type="radio"
															formControlName="isBusinessAddressRented"
															[value]="true"
														/>
														Yes
													</label>
													<label class="radio-answer">
														<input
															type="radio"
															formControlName="isBusinessAddressRented"
															[value]="false"
														/>
														No
													</label>
												</div>
											</div>
										</div>
									</div>
								</div>

								<div class="form-panel d-flex flex-column">
									<p>Business Owner Details</p>

									<div class="row">
										<div class="col-md-4 mb-3">
											<div class="input-group-div">
												<label>First Name</label>
												<input
													formControlName="firstName"
												/>
												<app-error-message
													[form]="basicForm"
													controlName="firstName"
													label="Business owner first name"
												></app-error-message>
											</div>
										</div>
										<div class="col-md-4 mb-3">
											<div class="input-group-div">
												<label>Last Name</label>
												<input
													formControlName="lastName"
												/>
												<app-error-message
													[form]="basicForm"
													controlName="lastName"
													label="Business owner last name"
												></app-error-message>
											</div>
										</div>

										<div class="col-md-4 mb-3">
											<div class="input-group-div">
												<label class="required"
													>ASIN</label
												>
												<input
													formControlName="ownerAsin"
												/>
												<app-error-message
													[form]="basicForm"
													controlName="ownerAsin"
													label="Business owner ASIN"
												></app-error-message>
											</div>
										</div>
										<div class="col-md-4 mb-3">
											<div class="input-group-div">
												<label>Gender</label>
												<select
													formControlName="gender"
													type="text"
												>
													<option
														value=""
														selected
													>
														- Select gender -
													</option>
													<option value="MALE">
														MALE
													</option>
													<option value="FEMALE">
														FEMALE
													</option>
												</select>
												<app-error-message
													[form]="basicForm"
													controlName="gender"
													label="Business owner gender"
												></app-error-message>
											</div>
										</div>
										<div class="col-md-4 mb-3">
											<div class="action-input-group">
												<label class="mb-0"
													>Business Email</label
												>
												<div class="input">
													<input
														formControlName="email"
														type="email"
														(change)="
															emailExist(
																basicForm.get(
																	'email'
																)
															)
														"
													/>

													<div
														class="spinner-border text-info"
														*ngIf="
															isCheckingIfEmailExists
														"
													></div>
												</div>
												<app-error-message
													[form]="basicForm"
													controlName="email"
													label="Business owner email"
												></app-error-message>
											</div>

											<div class="input-group-div"></div>
										</div>
										<div class="col-md-4 mb-3">
											<div class="input-group-div">
												<label class="required"
													>Phone Number</label
												>
												<input
													formControlName="phoneNumber"
												/>
												<app-error-message
													[form]="basicForm"
													controlName="phoneNumber"
													label="Business owner phone number"
												></app-error-message>
											</div>
										</div>
									</div>
								</div>

								<div class="form-panel">
									<p>Contact Person Information</p>
									<label
										class="d-flex flex-row align-items-center gap-1 me-auto"
									>
										<input
											[(ngModel)]="
												contactIsSameAsBusinessOwner
											"
											type="checkbox"
											(change)="logValue()"
											[ngModelOptions]="{
												standalone: true,
											}"
										/>

										<span
											style="color: #666; font-size: 14px"
											>Same As Business Owner</span
										>
									</label>
									<div
										class="row"
										*ngIf="!contactIsSameAsBusinessOwner"
									>
										<div class="col-md-4 mb-3">
											<div class="input-group-div">
												<label class="required"
													>First Name</label
												>
												<input
													formControlName="contactFirstName"
												/>
												<app-error-message
													[form]="basicForm"
													controlName="contactFirstName"
													label="Contact Person first name"
												></app-error-message>
											</div>
										</div>
										<div class="col-md-4 mb-3">
											<div class="input-group-div">
												<label class="required"
													>Last Name</label
												>
												<input
													formControlName="contactLastName"
												/>
												<app-error-message
													[form]="basicForm"
													controlName="contactLastName"
													label="Contact Person last name"
												></app-error-message>
											</div>
										</div>
										<div class="col-md-4 mb-3">
											<div class="input-group-div">
												<label class="required"
													>Email</label
												>
												<input
													type="email"
													name="contactEmail"
													formControlName="contactEmail"
												/>
												<app-error-message
													[form]="basicForm"
													controlName="contactEmail"
													label="Contact Person email"
												></app-error-message>
											</div>
										</div>
										<div class="col-md-4 mb-3">
											<div class="input-group-div">
												<label class="required"
													>Phone Number</label
												>
												<input
													formControlName="contactPhoneNumber"
												/>
												<app-error-message
													[form]="basicForm"
													controlName="contactPhoneNumber"
													label="Contact Person phone number"
												></app-error-message>
											</div>
										</div>
										<div class="col-md-4 mb-3">
											<div class="input-group-div">
												<label class="required"
													>Designation</label
												>
												<input
													formControlName="contactDesignation"
													placeholder="eg. Secretary"
												/>
												<app-error-message
													[form]="basicForm"
													controlName="contactDesignation"
													label="Contact Person designation"
												></app-error-message>
											</div>
										</div>
										<div class="col-md-4 mb-3">
											<div class="input-group-div">
												<label>Address</label>
												<input
													formControlName="contactAddress"
												/>
											</div>
											<app-error-message
												[form]="basicForm"
												controlName="contactAddress"
												label="Contact Person address"
											></app-error-message>
										</div>
									</div>
								</div>

								<br />

								<div class="form-panel">
									<p>Additionals Information</p>

									<div class="d-flex">
										<span
											class="me-2 required"
											style="color: #666; font-size: 14px"
											>Is business solely online?</span
										>
										<div
											class="d-flex flex-row align-items-center"
										>
											<div
												class="d-flex flex-row align-items-center me-4"
											>
												<label
													style="font-size: 12px"
													class="radio-answer"
												>
													<input
														name="solelyOnline"
														formControlName="solelyOnline"
														[value]="true"
														type="radio"
													/>
													Yes</label
												>
											</div>
											<div
												class="d-flex flex-row align-items-center"
											>
												<label
													style="font-size: 12px"
													class="radio-answer"
												>
													<input
														name="solelyOnline"
														formControlName="solelyOnline"
														[value]="false"
														type="radio"
													/>No</label
												>
											</div>
										</div>
									</div>

									<div class="row">
										<div class="col-md-4 mb-3">
											<div class="input-group-div">
												<label class="required"
													>Estimated Monthly
													Revenue</label
												>
												<input
													formControlName="estimatedRevenue"
													type="number"
													min="0"
												/>
												<app-error-message
													[form]="basicForm"
													controlName="estimatedRevenue"
													label="Est. monthly revenue"
												></app-error-message>
											</div>
										</div>

										<div class="col-md-4 mb-3">
											<div class="input-group-div">
												<label class="required"
													>Nature Of Business
													Operation</label
												>
												<select
													formControlName="natureOfBusiness"
												>
													<option
														selected
														disabled
													>
														-- SELECT OPTION --
													</option>
													<option
														*ngFor="
															let nature of nbList
														"
														[value]="nature.id"
													>
														{{
															nature.name
																| titlecase
														}}
													</option>
												</select>
												<app-error-message
													[form]="basicForm"
													controlName="natureOfBusiness"
													label="Nature Of business"
												></app-error-message>
											</div>
										</div>

										<div class="col-md-4 mb-3">
											<span
												class="me-2 required"
												style="
													color: #666;
													font-size: 14px;
												"
												>Do you have access to any form
												of business financing, such as
												loan?</span
											>
											<div
												class="d-flex flex-row align-items-center gap-2"
											>
												<div
													class="d-flex flex-row align-items-center"
												>
													<label
														style="font-size: 12px"
														class="radio-answer"
														><input
															name="hasAccessToFinancing"
															formControlName="hasAccessToFinancing"
															[value]="true"
															type="radio"
														/>Yes</label
													>
												</div>
												<div
													class="d-flex flex-row align-items-center"
												>
													<label
														style="font-size: 12px"
														class="radio-answer"
														><input
															name="hasAccessToFinancing"
															formControlName="hasAccessToFinancing"
															[value]="false"
															type="radio"
														/>No</label
													>
												</div>
												<div
													class="d-flex flex-row align-items-center"
												>
													<label
														style="font-size: 12px"
														class="radio-answer"
													>
														<input
															name="hasAccessToFinancing"
															formControlName="hasAccessToFinancing"
															[value]="'MAYBE'"
															type="radio"
														/>
														Maybe</label
													>
												</div>
											</div>
											<app-error-message
												[form]="basicForm"
												controlName="hasAccessToFinancing"
												label="Nature Of business"
											></app-error-message>
										</div>
									</div>
								</div>
							</div>
							<br />

							<div class="form-panel">
								<p>Create Login Password</p>

								<div class="row">
									<div class="col-md-4 mb-3">
										<div class="input-group-div">
											<label>Password</label>
											<input
												type="password"
												name="anythingtostopdefault"
												formControlName="password"
											/>
											<app-error-message
												[form]="basicForm"
												controlName="password"
												label="Password"
											></app-error-message>
										</div>
									</div>
									<div class="col-md-4 mb-3">
										<div class="input-group-div">
											<label>Confirm Password</label>
											<input
												type="password"
												formControlName="confirmPassword"
											/>
											<app-error-message
												[form]="basicForm"
												controlName="confirmPassword"
												label="Confirm Password"
											></app-error-message>
										</div>
									</div>
								</div>
							</div>

							<div
								class="authentication"
								*ngIf="isInPreviewMode"
							>
								<div class="wrapper">
									<div
										class="verification-question mb-3 d-inline-flex gap-3"
									>
										<span class="fw-bolder mb-0"
											>Please enter the one-time password
											(OTP) sent to your email/phone
											number.</span
										>
									</div>
									<form [formGroup]="otpForm">
										<div class="w-100">
											<div
												class="action-input-group mb-0"
											>
												<div
													class="input verify-otp-input"
												>
													<input
														placeholder="ENTER OTP"
														appOnlyNumber
														formControlName="otp"
													/>
													<button
														class="btn btn-secondary send-otp-btn"
														(click)="verifyOTP()"
														type="button"
														[disabled]="
															otpForm.get('otp')
																.invalid
														"
													>
														<span
															*ngIf="
																!isVerifyingOTP
															"
															>VERIFY</span
														>
														<div
															class="spinner-border text-white"
															*ngIf="
																isVerifyingOTP
															"
														></div>
													</button>
												</div>

												<app-error-message
													[form]="otpForm"
													controlName="otp"
													label="OTP"
												></app-error-message>
											</div>
										</div>
										<div class="buttons">
											<button
												class="btn btn-success d-flex justify-content-center align-items-center gap-2"
												(click)="sendOTPtoEmail()"
											>
												Resend Code via EMAIL
												<span
													class="material-icons"
													*ngIf="!isSendingOTPtoEmail"
												>
													send
												</span>
												<b
													*ngIf="isSendingOTPtoEmail"
													class="spinner-border text-white"
												></b>
											</button>
											<button
												class="btn btn-dark d-flex justify-content-center align-items-center gap-2"
												(click)="sendOTPtoSMS()"
											>
												<b
													*ngIf="
														emailPhone === 'sms' &&
														isLoading
													"
													class="spinner-border text-white"
												></b>
												Resend Code via SMS
												<span class="material-icons">
													mail
												</span>
											</button>
										</div>
									</form>
								</div>
							</div>

							<div class="submit-div mt-3 row">
								<div class="col-md-6">
									<button
										type="button"
										style="height: 47px; width: 100%"
										class="cancel"
										(click)="cancel()"
									>
										Cancel
									</button>
								</div>
								<div class="col-md-6">
									<button
										*ngIf="!isInPreviewMode"
										type="button"
										style="height: 47px; width: 100%"
										class="button"
										[disabled]="basicForm.invalid"
										(click)="nextStep()"
									>
										Save & Proceed
									</button>

									<button
										*ngIf="isInPreviewMode"
										type="submit"
										[disabled]="!allowSubmission"
										style="height: 47px; width: 100%"
										class="button d-flex justify-content-center align-items-center gap-2"
									>
										<b
											*ngIf="isSubmitting"
											class="spinner-border text-white"
										></b>
										Submit Request
									</button>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	</div>

	<app-footer></app-footer>
</div>
